import { render, staticRenderFns } from "./PageTitleUpdate.vue?vue&type=template&id=68e0c981"
import script from "./PageTitleUpdate.vue?vue&type=script&lang=ts"
export * from "./PageTitleUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports